import PropTypes from 'prop-types';
import css from './Quote.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Quote = function Quote(_ref) {
  var name = _ref.name,
      text = _ref.text;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      "aria-hidden": "true",
      className: css.quote,
      role: "presentation",
      children: "\u201C"
    }), /*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsx("span", {
        dangerouslySetInnerHTML: {
          __html: text
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), "-", name]
    })]
  });
};

Quote.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};
export default Quote;